import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@/hooks/useToast';
import {
  approveApplication,
  rejectApplication,
} from '@/server/applications.functions';

export const useApplicationAction = () => {
  const queryClient = useQueryClient();
  const { push } = useToast();

  return useMutation({
    mutationFn: (vars: {
      action: 'approve' | 'reject';
      applicationId: number;
    }) =>
      vars.action === 'approve'
        ? approveApplication({ data: { id: vars.applicationId } })
        : rejectApplication({ data: { id: vars.applicationId } }),
    onError: (error: Error) => push(error.message || 'Action failed', 'error'),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['jobs'] });
      queryClient.invalidateQueries({ queryKey: ['stats'] });
    },
  });
};
